var sessionStorageManager = require('store2').session
var localStorageManager = require('store2')

var getSessionData = (key) => {
  try {
    return sessionStorageManager.get(key)
  } catch (e) {
    return null
  }
}

var saveSessionData = (key, value) => {
  try {
    sessionStorageManager.set(key, value)
  } catch (e) {
    // Suppress storage restriction errors in Safari
  }
}

var getLocalData = (key) => {
  try {
    return localStorageManager.get(key)
  } catch (e) {
    return null
  }
}

var saveLocalData = (key, value) => {
  try {
    localStorageManager.set(key, value)
  } catch (e) {
    // Suppress storage restriction errors in Safari
  }
}

export const Storage = {
  Get: getSessionData,
  Save: saveSessionData,
  GetLocal: getLocalData,
  SaveLocal: saveLocalData,
  GetSession: getSessionData,
  SaveSession: saveSessionData
}
export default Storage
